import {styled} from '@mui/material';

export const HighlightedMark = styled('mark')`
	background-color: ${({theme}) => theme.palette.customWarning.light};
`;
